import React from 'react';
import { Link } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';

const NotFound = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-white">
      <div className="max-w-md mx-auto text-center px-6">
        <div className="mb-8">
          <h1 className="text-9xl font-extrabold text-gray-200">404</h1>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#211033] text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors duration-200"
          >
            <BiArrowBack />
            Go Home
          </Link>
          
          <div className="text-sm text-gray-500">
            <Link to="/portfolio" className="text-[#e83310] hover:underline">
              View Portfolio
            </Link>
            {' • '}
            <Link to="/contact" className="text-[#e83310] hover:underline">
              Contact Me
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
